import React, { useEffect, useState } from "react"
import { Box, Grid, InputLabel, TextField, Typography } from "@mui/material"
import * as Style from "./Style"
import Button from "@mui/material/Button"
import MenuItem from "@mui/material/MenuItem"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { useForm } from "react-hook-form"
import { useAppSelector } from "../../app/hooks"
import { useAppDispatch } from "../../app/store"
import { setString } from "../../features/Auth/WrapperSlice"
import { useGetCountrysQuery } from "../../features/Auth/authApi"
import LocationSelect from "../location/locationSelect"

interface PersonalAccount {
  name: string
  email: string
  contactNo: string
  gender: string
  dob: string
  region: string
}

interface PersonalStepProps {
  activeStep: string
  step: string
  handleNext: () => void
  handleBack: () => void
}
const PersonalStep: React.FC<PersonalStepProps> = ({
  activeStep,
  step,
  handleNext,
  handleBack,
}) => {
  const dispatch = useAppDispatch()
  const { data: countryList } = useGetCountrysQuery({})
  const [loactionSearchData, setLocationSearchData] = useState<string>("")
  const [errorMsg, setErrorMsg] = useState<string>()
  const [isFocused, setIsFocused] = useState({ country: false, gender: false })
  const stringValue = useAppSelector((state) => state?.wrapper?.stringValue)
  const userId = useAppSelector((state) => state.auth.userDetails)
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  const schemaResolver = yupResolver(
    yup.object().shape({
      name: yup
        .string()
        .required("Please Enter First Name")
        .min(3, "Name Must Be At Least 3 Characters")
        .max(25, "Name Can't Exceed 25 Characters"),
      email: yup
        .string()
        .required("Please Enter An Email")
        .test("Valid-Email", "Please Enter A Valid Email", (value) =>
          emailRegex.test(value),
        ),
      contactNo: yup
        .string()
        .required("Please Enter A Phone Number")
        .min(6, "Phone Number Must Be At Least 6 Characters")
        .max(14, "Phone Number Can't Exceed 14 Characters"),
      gender: yup.string().required("Please Select Your Gender"),
      dob: yup
        .string()
        .required("Please Enter Your Date Of Birth")
         .test(
         "Age",
         "The Provider's Age Must Be 18 Or Above.",
          function (value) {
            const dob = new Date(value)
            const today = new Date()
            
            const age = today.getFullYear() - dob.getFullYear()
            const hasHadBirthdayThisYear =
              today.getMonth() > dob.getMonth() ||
              (today.getMonth() === dob.getMonth() &&
                today.getDate() >= dob.getDate())

            const exactAge = hasHadBirthdayThisYear ? age : age - 1

            return exactAge >= 18
          },
        ),

      region: yup.string().required("Please Select Your Country"),
    }),
  )
  const {
    control,
    register,
    setValue,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm<PersonalAccount>({
    resolver: schemaResolver,
  })

  const onSubmit = (value: any) => {
    dispatch(
      setString({
        ...stringValue,
        name: value?.name,
        email: value?.email,
        contactNo: value?.contactNo,
        gender: value?.gender,
        region: value?.region,
        address: loactionSearchData,
        dob: value?.dob,
      }),
    )
    if (loactionSearchData !== "" && loactionSearchData !== undefined) {
      handleNext()
    } else {
      setErrorMsg("Please Enter Your Location")
    }
  }

  useEffect(() => {
    const user = userId?.user
    if (user) {
      setValue("name", user?.name || "")
      setValue("email", user?.email || "")
      setValue("contactNo", user?.contactNo || "")
      setValue("dob", user?.dob || "")
      setValue("gender", user?.gender || "")
      setValue("region", user?.region || "")
      setLocationSearchData(user?.address || "")
    }

    if (stringValue) {
      setValue("name", userId?.user?.name || stringValue?.name)
      setValue("email", userId?.user?.email || stringValue?.email)
      setValue("contactNo", stringValue?.contactNo || userId?.user?.contactNo)
      setValue("dob", stringValue?.dob || userId?.user?.dob)
      setValue("gender", stringValue?.gender || userId?.user?.gender)
      setValue("region", stringValue?.region || userId?.user?.region)
      setLocationSearchData(stringValue?.address || userId?.user?.address || "")
    }
  }, [userId, stringValue, setValue])

  return (
    <Style.PersonalInfo style={{ padding: "0px" }}>
      <Grid>
        <Grid item xs={12}>
          <Box sx={{ width: "100%" }}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Box className="py-3">
                <Typography sx={{ m: 0 }}>
                  <Box
                    className="d-flex"
                    component="form"
                    sx={{
                      "& > :not(style)": { mx: 2 },
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <Box>
                      <InputLabel sx={{ mb: 2 }} htmlFor="outlined-basic">
                        Name<span className="text-danger">*</span>
                      </InputLabel>

                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        className="form-input"
                        {...register("name")}
                        disabled
                      />
                      <p className="text-danger"> {errors?.name?.message}</p>
                    </Box>
                    <Box>
                      <InputLabel sx={{ mb: 2 }} htmlFor="outlined-basic">
                        Email<span className="text-danger">*</span>
                      </InputLabel>
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        className="form-input "
                        {...register("email")}
                        disabled
                      />
                      <p className="text-danger"> {errors?.email?.message}</p>
                    </Box>
                  </Box>
                </Typography>
                <Typography sx={{ m: 0 }}>
                  <Box
                    className="d-flex"
                    component="form"
                    sx={{
                      "& > :not(style)": { mx: 2 },
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <Box>
                      <InputLabel sx={{ mb: 2 }} htmlFor="outlined-basic">
                        Phone Number<span className="text-danger">*</span>
                      </InputLabel>
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        placeholder="Enter Phone Number"
                        className="form-input"
                        type="number"
                        {...register("contactNo")}
                        // disabled
                      />
                      <p className="text-danger">
                        {" "}
                        {errors?.contactNo?.message}
                      </p>
                    </Box>
                    <Box
                      component="form"
                      sx={{
                        "& > :not(style)": { mb: 2 },
                      }}
                      noValidate
                      autoComplete="off"
                    >
                      <InputLabel sx={{ mb: 2 }} htmlFor="outlined-basic">
                        Gender<span className="text-danger">*</span>
                      </InputLabel>
                      <TextField
                        id="filled-select-currency"
                        select
                        variant="filled"
                        className="form-input custom-dropdown mb-1"
                        defaultValue={stringValue?.gender}
                        value={watch("gender")}
                        label={
                          isFocused.gender || stringValue?.gender
                            ? ""
                            : "Gender"
                        }
                        {...register("gender")}
                        onChange={(e) => {
                          const gender = e.target.value
                          setValue("gender" as any, gender as any, {
                            shouldValidate: true,
                          })

                          const temp = { ...isFocused, gender: true }
                          setIsFocused(temp)
                        }}
                      >
                        <MenuItem value="Male">Male</MenuItem>
                        <MenuItem value="Female">Female</MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                      </TextField>
                      <p className="text-danger"> {errors?.gender?.message}</p>
                    </Box>
                  </Box>
                </Typography>
                <Typography sx={{ m: 0 }}>
                  <Box
                    className="d-flex"
                    component="form"
                    sx={{
                      "& > :not(style)": { mx: 2 },
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <Box>
                      <InputLabel sx={{ mb: 2 }} htmlFor="outlined-basic">
                        Date Of Birth<span className="text-danger">*</span>
                      </InputLabel>
                      <TextField
                        id="outlined-basic"
                        max="2000-01-02"
                        variant="outlined"
                        className="form-input"
                        type="date"
                        {...register("dob")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                         inputProps: {
                            max: new Date(new Date().setFullYear(new Date().getFullYear() - 18))
                              .toISOString()
                              .split('T')[0],
                          },
                          inputComponent: (props) => (
                            <input
                              {...props}
                              pattern="[0-9]{4}"
                              title="Please enter a four-digit year"
                            />
                          ),
                        }}
                        sx={{
                          '& input[type="date"]': {
                            position: 'relative',
                            paddingRight: '40px',
                            appearance: 'none',
                            MozAppearance: 'textfield', // Firefox
                          },
                          // For Firefox
                          '& input[type="date"]::-moz-focus-inner': {
                            border: 0,
                          },
                          '& input[type="date"]::-moz-clear': {
                            display: 'none',
                          },
                          '& input[type="date"]::-moz-ui-invalid': {
                            boxShadow: 'none',
                          },
                        }}
                      />
                      <p
                        className="text-danger mt-1"
                        style={{ maxWidth: "300px" }}
                      >
                        {" "}
                        {errors?.dob?.message}
                      </p>
                    </Box>
                    <Box
                      component="form"
                      sx={{
                        "& > :not(style)": { mb: 2 },
                      }}
                      noValidate
                      autoComplete="off"
                    >
                      <InputLabel sx={{ mb: 2 }} htmlFor="outlined-basic">
                        Country<span className="text-danger">*</span>
                      </InputLabel>
                      <TextField
                        id="filled-select-currency"
                        select
                        variant="filled"
                        className="form-input mb-1"
                        defaultValue={stringValue?.region}
                        value={watch("region")}
                        label={
                          isFocused.country || stringValue?.region
                            ? ""
                            : "Country"
                        }
                        {...register("region")}
                        onChange={(e) => {
                          const region = e.target.value
                          setValue("region" as any, region as any, {
                            shouldValidate: true,
                          })
                          const temp = { ...isFocused, country: true }
                          setIsFocused(temp)
                        }}
                        SelectProps={{
                          MenuProps: {
                            PaperProps: {
                              style: {
                                maxHeight: 250,
                                width: 150,
                                overflowY: "auto",
                                scrollbarWidth: "thin",
                                scrollbarColor: "#f07fa9 transparent",
                                borderRadius: "12px",
                                cursor: "pointer",
                              },
                            },
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "left",
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "left",
                            },
                          },
                        }}
                      >
                        {countryList?.countries &&
                          countryList?.countries?.map((option: any) => (
                            <MenuItem key={option?.name} value={option?.name}>
                              {option?.name}
                            </MenuItem>
                          ))}
                      </TextField>
                      <p className="text-danger"> {errors?.region?.message}</p>
                    </Box>
                  </Box>
                </Typography>
                <Typography sx={{ m: 0 }}>
                  <Box className="d-flex mx-3">
                    <Box>
                      <InputLabel sx={{ mb: 2 }} htmlFor="outlined-basic">
                        Location<span className="text-danger">*</span>
                      </InputLabel>

                      <Box
                        sx={{
                          width: 300,
                          "@media (max-width: 600px)": {
                            width: 200,
                          },
                        }}
                      >
                        <LocationSelect
                          placeholder="Enter Location"
                          setLocationSearchData={setLocationSearchData}
                          setErrorMsg={setErrorMsg}
                          loactionSearchData={loactionSearchData}
                        />
                      </Box>
                      <p className="text-danger mt-2">{errorMsg}</p>
                    </Box>
                  </Box>
                </Typography>
              </Box>
              <Box className="d-flex mx-3">
                {(activeStep as any) === 0 ? (
                  ""
                ) : (
                  <Button
                    color="inherit"
                    disabled={(activeStep as any) === 0}
                    onClick={handleBack}
                    sx={{ mr: 1 }}
                    className="next-button "
                  >
                    Back
                  </Button>
                )}
                <Button type="submit" className="next-button grey-button">
                  {(activeStep as any) === step.length - 1 ? "Finish" : "Next"}
                </Button>
              </Box>
            </form>
          </Box>
        </Grid>
      </Grid>
    </Style.PersonalInfo>
  )
}

export default PersonalStep
